import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="p-24 text-center text-navy/50">Checking session…</div>;
  if (user && user.role === "admin") return <Navigate to="/admin/dashboard" replace />;

  const handle = async (e) => {
    e.preventDefault();
    setError(""); setSubmitting(true);
    const r = await login(email, password);
    if (!r.ok) setError(r.error);
    setSubmitting(false);
  };

  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="admin-login">
      <div className="w-full max-w-md rounded-3xl bg-white p-10 shadow-xl ring-1 ring-silver-light">
        <div className="w-14 h-14 rounded-2xl bg-navy-dark text-white flex items-center justify-center mx-auto"><Lock size={22} /></div>
        <h1 className="font-serif text-3xl text-navy-dark text-center mt-6">Admin sign in</h1>
        <p className="text-sm text-navy/60 text-center mt-1">Collins Crafty Creations control panel</p>
        <form onSubmit={handle} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div><Label>Email</Label><Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" /></div>
          <div><Label>Password</Label><Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" /></div>
          {error && <div className="text-sm text-cpr" data-testid="admin-login-error">{error}</div>}
          <Button type="submit" disabled={submitting} className="w-full bg-navy-dark text-white rounded-full py-6 font-semibold" data-testid="admin-login-submit">
            {submitting ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </section>
  );
}
